import { Button } from "theme-ui";

import { Decimal } from "@liquity/lib-base";

import { useLiquity } from "../../hooks/LiquityContext";
import { useTransactionFunction } from "../Transaction";

type StakingActionProps = {
  change: Decimal;
  sprintType: string;
};

export const StakingManagerAction: React.FC<StakingActionProps> = ({ change, sprintType, children }) => {
  const { liquity } = useLiquity();
  const amount = change ? change : 0;

  const [sendTransaction] = useTransactionFunction(
    "sprint",
    sprintType == "stake"
      ? liquity.send.stakeSPrint.bind(liquity.send, amount)
      : liquity.send.unstakeSPrint.bind(liquity.send, amount)
  );

  return <Button onClick={sendTransaction}>{children}</Button>;
};
